import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { doc, setDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { auth, googleProvider } from "../config/firebase";
import { toast } from "react-toastify";
import { db } from "../config/firebase";
import "../css/Auth.css";

const INTER_FONT = "'Inter', Arial, Helvetica, sans-serif";

export default function SignUp() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
    setLoading(true);

    try {
      console.log("Step 1: starting signup");
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      console.log("Step 2: auth account created, writing to Firestore...");
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        name: formData.fullName,
        role: "client",
        createdAt: serverTimestamp(),
        rewards: {
          currentPoints: 0,
          totalEarned: 0,
          rewardsRedeemed: 0,
        },
      });

      console.log("Step 3: Firestore write complete");
      toast.success("Account created!");
      navigate("/");
    } catch (error) {
      console.error("FULL ERROR:", error);  // this will show the real problem
      toast.error(error.message);
    } finally {
      setLoading(false);  // ADD THIS — guarantees button unsticks even if something fails
    }
  };

  const handleGoogleSignUp = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Check if doc already exists (Google users can sign in multiple times)
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (!userDoc.exists()) {
        await setDoc(doc(db, "users", user.uid), {
          email: user.email,
          name: user.displayName,
          role: "client",
          createdAt: serverTimestamp(),
          rewards: {
            currentPoints: 0,
            totalEarned: 0,
            rewardsRedeemed: 0,
          },
        });
      }

      toast.success("Signed up with Google!");
      navigate("/");
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div
      className="auth-container"
      style={{
        fontFamily: INTER_FONT,
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflowX: "hidden", // prevents white strip issue
      }}
    >
      {/* Background video */}
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "fixed", // keeps video pinned in place
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src="/videos/PavilionVid.mp4" type="video/mp4" />
      </video>

      {/* Centered card */}
      <form
        className="auth-form"
        onSubmit={handleSubmit}
        style={{
          fontFamily: INTER_FONT,
          zIndex: 1, // keep the card above the video
        }}
      >
        <h2 style={{ fontFamily: INTER_FONT, fontWeight: 700 }}>Sign Up</h2>

        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          required
          style={{ fontFamily: INTER_FONT }}
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          style={{ fontFamily: INTER_FONT }}
        />
        <p style={{ fontFamily: INTER_FONT, fontSize: "0.8rem", opacity: 0.75, margin: "-8px 0 4px" }}>
          Rewards are shared with Agape Prime Hotel — use the same email there too if you want one combined points balance.
        </p>

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
          style={{ fontFamily: INTER_FONT }}
        />

        <button
          type="submit"
          disabled={loading}
          className={loading ? "loading" : ""}
          style={{ fontFamily: INTER_FONT, fontWeight: 700 }}
        >
          {loading ? "Creating..." : "Create Account"}
        </button>

        <button
          type="button"
          className={`google-btn ${loading ? "loading" : ""}`}
          onClick={handleGoogleSignUp}
          disabled={loading}
          style={{ fontFamily: INTER_FONT, fontWeight: 700 }}
        >
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google logo"
          />
          {loading ? "Please wait..." : "Sign up with Google"}
        </button>

        <p className="switch-link" style={{ fontFamily: INTER_FONT }}>
          Already have an account?{" "}
          <span
            onClick={() => navigate("/sign-in")}
            style={{
              cursor: "pointer",
              fontFamily: INTER_FONT,
              textDecoration: "underline",
            }}
          >
            Sign In
          </span>
        </p>
      </form>
    </div>
  );
}
